import React, { RefObject} from "react";
import BG1 from '../../assets/images/BG1.jpg';
import BG2 from '../../assets/images/BG2.jpeg';
import BG3 from '../../assets/images/BG3.png';
import BG4 from '../../assets/images/BG4.jpeg';
import BG5 from '../../assets/images/BG5.png';

const backgrounds = [BG1, BG2, BG3, BG4, BG5];

interface RotatingBackgroundProps {
  elRef: RefObject<HTMLElement>;
}
const RotatingBackground = (props: RotatingBackgroundProps) => {
  const { elRef } = props;
  React.useEffect(() => {
    if (elRef.current) {
      const img = backgrounds[Math.floor(Math.random() * backgrounds.length)];
      elRef.current.style.backgroundImage = `url(${img})`;
      elRef.current.style.backgroundSize = 'cover';
      elRef.current.style.backgroundPosition = 'center';
    }

  }, [elRef?.current])

  return null;
}

export default RotatingBackground;